<template>
  <div class="Notif__container" :class="{'has--notifs' : notifs.length > 0}">
    <AppNotif v-for="notif in notifs" :notif="notif" :key="notif.id"/>
    <div class="Notif__overlay" @click.prevent="closeNotif"></div>
  </div>
</template>

<script>
  import { useNotifs } from '@/store/notifs'
  import AppNotif from "@components/app/AppNotif";
  import {onMounted, onUnmounted} from "vue";
  import {Inertia} from "@inertiajs/inertia";

  export default {
    components : { AppNotif },
    setup() {

      const closeNotif = () => useNotifs.delete()

      let notifListener = null;

      onMounted(() => {
        notifListener = Inertia.on('success', () => {

          const {popup_notification} = Inertia.page.props;
          if (popup_notification){
            useNotifs.push(popup_notification)
          } else {
            useNotifs.delete()
          }
        })
      })

      onUnmounted(() => notifListener())

      return {
        notifs : useNotifs.get(),
        closeNotif
      }
    }
  }
</script>
